// extracted by mini-css-extract-plugin
module.exports = {"verifiedCharity":"jgp-bYeyY"};